export function isTodoNoteFavorite(item: { is_favorite?: boolean | null }): boolean {
  return Boolean(item.is_favorite);
}

/** 같은 id의 즐겨찾기 플래그를 source에서 덮어쓴다(대시보드 ↔ 노트 keep-alive). */
export function applyTodoFavoriteFlagsFromSource<T extends { id: string; is_favorite?: boolean | null }>(
  items: T[],
  sourceItems: Array<{ id: string; is_favorite?: boolean | null }>
): T[] {
  if (!items.length || !sourceItems.length) return items;
  const favById = new Map(sourceItems.map((it) => [it.id, isTodoNoteFavorite(it)]));
  let changed = false;
  const next = items.map((it) => {
    if (!favById.has(it.id)) return it;
    const is_favorite = favById.get(it.id) as boolean;
    if (isTodoNoteFavorite(it) === is_favorite) return it;
    changed = true;
    return { ...it, is_favorite };
  });
  return changed ? next : items;
}

export function compareTodoFavoriteFirst(
  a: { is_favorite?: boolean | null },
  b: { is_favorite?: boolean | null }
): number {
  const fa = isTodoNoteFavorite(a);
  const fb = isTodoNoteFavorite(b);
  if (fa === fb) return 0;
  return fa ? -1 : 1;
}

export const TODO_POSTIT_FAVORITE_GROUP_KEY = '__favorite__';
